import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "share",
  "use": "share-usage",
  "viewBox": "0 0 17 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 14\" id=\"share\"><g fill=\"none\" fill-rule=\"evenodd\"><path stroke=\"#000\" d=\"M8.018 2.242H1.11v10.49h13.333V8.025\" /><path d=\"M16.68 4.03L12.074.453v1.918c-5.762 1.447-5.39 5.416-5.39 5.416 2.566-2.243 5.39-1.698 5.39-1.698v1.698l4.604-3.757z\" fill=\"#000\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol